import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({
  'your.career.turning.point': {
    id: 'your.career.turning.point',
    defaultMessage: 'Your career turning point',
    description: 'Part of the heading "Your career turning point is here." shown on Authn MFE',
  },
  'is.here': {
    id: 'is.here',
    defaultMessage: 'is here.',
    description: 'Part of the heading "Your career turning point is here." shown on Authn MFE',
  },
});

export default messages;
